module.exports = __webpack_public_path__ + "static/media/agent.38862af9.jpg";